
document.addEventListener("DOMContentLoaded", async () => {
  (new URLSearchParams(window.location.search)).has("modal_filter") && toggleFiltering();
  const maker = requestPathName.replace("/pages/purchase-record", "")?.replace("/", "").replace(" ", "");
  console.log({ maker });
  if (maker) {
    createFilterdRecordsElement({ maker });
  }
  recordMakerFiltering({ requestPathName });
  if (localStorage.getItem('scrollPosition')) {
    window.scrollTo(0, parseInt(localStorage.getItem('scrollPosition')));
    localStorage.removeItem('scrollPosition');
  }
});


// クリックされた要素のIDと同じ data-accordion-id を持つ要素を開閉する
function toggleAccordion() {
  const accordionId = event.target.id;
  console.log(accordionId);
  const panel = document.querySelector(`[data-accordion-id="${accordionId}"]`);
  const arrow = document.querySelector(`#${accordionId} .accordion-arrow`);
  if (panel) {
    if (panel.style.maxHeight !== "0px" || panel.style.maxHeight === "100%") {
      panel.style.maxHeight = "0px";
      panel.style.marginTop = "0px";
      arrow.style.transform = "rotate(0deg)";
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
      panel.style.marginTop = "16px";
      arrow.style.transform = "rotate(180deg)";
    }
  }
}
function recordMakerFiltering({ requestPathName }) {
  const makerRadioButtons = document.querySelectorAll('input[type="radio"][name="filtering-maker"]');
  makerRadioButtons.forEach(function (radioButton) {
    radioButton.addEventListener("change", function () {
      // 表示している画面幅
      const windowWidth = window.innerWidth;
      const mobileFilteringModal = windowWidth < 768;
      const redirectPath = `/pages/purchase-record/${decodeURIComponent(radioButton.id?.replace("maker_", "") || "")}${mobileFilteringModal ? "?modal_filter=true" : ""}`;
      localStorage.setItem('scrollPosition', window.scrollY || document.documentElement.scrollTop);
      window.location.href = redirectPath;
    });
  });
}
function createFilterdRecordsElement({ maker }) {
  document.getElementById("pagination-area").innerHTML = ""; // 初期化
  const makerRadio = document.getElementById(`maker_${maker}`);
  if (makerRadio) {
    makerRadio.checked = true;
  } else {
    document.getElementById("maker_").checked = true;
  }
  const filterdRecords = recordAllJson.filter(record => {
    console.log("state:", record.purchase_maker);
    return record.purchase_maker === maker;
  });
  console.log({ recordAllJson, filterdRecords });
  insertFilterdRecords({ filterdRecords });
  // フィルターの項目に商品名一覧を表示
  document.getElementById("is-checked-product-name").style.display = "block";
  const productTitleList = [...new Set(filterdRecords.map(record => {
    console.log(record.purchase_title);
    return record.purchase_title;
  }))];
  console.log({ productTitleList });
  const productListArea = document.getElementById("product-title-list");
  productListArea.innerHTML = ""; // 初期化
  productTitleList.forEach((title, index) => {
    productListArea.insertAdjacentHTML("beforeend", `
    <li class="filtering-data-item">
      <input
        type="radio"
        name="filtering-product-title"
        class=""
        onChange="filteringRecordsByProductName('${title}')"
        id="product-title_${title}">
      <label for="product-title_${title}">
        ${title}
      </label>
    </li>
    `);
  });
  // #product-title-list の高さを設定
  const productTitleListHeight = productListArea.scrollHeight;
  productListArea.style.maxHeight = productTitleListHeight + "px";

  document.getElementById("filtering-count").innerText = `${filterdRecords.length} 件見つかりました`;
}

function insertFilterdRecords({ filterdRecords }) {
  const recordsArea = document.getElementById("product-grid");
  recordsArea.innerHTML = ""; // 初期化
  filterdRecords.forEach(({ purchase_image_url, purchase_sample_image, purchase_sample_image_url, purchase_title, purchase_id, purchase_date, purchase_condition, purchase_price }, index) => {
    recordsArea.insertAdjacentHTML("beforeend", `<li
      class="grid__item scroll-trigger animate--slide-in"
      data-cascade
      style="--animation-order: ${index};">
        <div class="purchase-item">
          <div class="purchase-item_detais-wrapper">
            <div class="purchase-item_image-wrapper" style="position: relative; display: block;">
              <img
                src="${purchase_image_url}"
                alt="${purchase_title}"
                class="purchase-item_image"
                loading="lazy">
                ${purchase_sample_image ? "" : `
                <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;">
                  <img
                    src="${purchase_sample_image_url}"
                    alt="サンプル画像"
                    style="width: 100%; height: 100%; object-fit: cover;background-color: #b2b2b23d;border-radius: 8px;">
                </div>`}
            </div>
            <div class="purchase-item_details">
              <h3 class="purchase-item_title">${purchase_title}</h3>
              <p class="purchase-item_id">
                買取ID：
                <strong>${purchase_id}</strong>
              </p>
              <p class="purchase-item_date">
                買取日：
                <strong>${purchase_date}</strong>
              </p>
              <div class="purchase-item_condition">
                <span class="purchase-item_condition-state-label">状態：</span>
                <span class="purchase-item_condition-state-data">${purchase_condition}</span>
              </div>
            </div>
          </div>
          <div class="purchase-item_price-wrapper">
            <p class="purchase-item_price">
              <span class="purchase-item_price-label">買取価格</span>
              <strong class="purchase-item_price-amount">${purchase_price}</strong>
              <span class="purchase-item_yen">円</span>
            </p>
          </div>
        </div>
      </li>`);
  });
  if (filterdRecords.length === 0) {
    recordsArea.innerHTML = `<p class="no-records">該当する買取記録はありません。</p>`;
  }
}

function filteringRecordsByProductName(title) {
  const filterdRecords = recordAllJson.filter(record => {
    return record.purchase_title === title;
  });
  insertFilterdRecords({ filterdRecords });
  document.getElementById("filtering-count").innerText = `${filterdRecords.length} 件見つかりました`;

}

function toggleFiltering() {
  console.log("toggleFiltering");
  const filteringContent = document.querySelector("aside.purchase-record-filtering");
  if (filteringContent) {
    if (filteringContent.classList.contains("active")) {
      filteringContent.classList.remove("active");
    } else {
      filteringContent.classList.add("active");
    }
  }
}